document.addEventListener('turbo:load', () => {
  const trackEvent = event => {
    if (event.target.dataset && event.target.dataset.tracking) {
      const options = JSON.parse(event.target.dataset.tracking);

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'eventTracking',
          eventType: event.type,
          eventCategory: options.category,
          eventAction: options.action,
          eventLabel: options.label,
          eventValue: options.value
        });
      }
    }
  };

  const trackedElements = Array.from(document.querySelectorAll('[data-tracking]'));

  trackedElements.forEach(element => {
    element.addEventListener('click', event => trackEvent(event), true);
    element.addEventListener('submit', event => trackEvent(event), true);
  });
});
